import { FC, useState } from "react"
import { QueryPageableRequest, QueryPageableResponse } from "../../../core/type"
import { UserFindRequest, UserRole } from "../../user/type/user-query"
import { gql, TypedDocumentNode, useMutation, useQuery } from "@apollo/client"
import { User } from "../../user/type"
import { AppraiserUpdate } from "../graphql/appraisal.graphql"
import { message, Select, Space } from "antd"
import { translate } from "../../../core"
import Enumerable from "linq"

export const GetUsers: TypedDocumentNode<QueryPageableResponse<User, 'usersFind'>, QueryPageableRequest<UserFindRequest>> = gql`
    query GetUsers($request: UserFindRequest!) {
        usersFind(request: $request) {
            data {
                id
                name
            }
        }
    }
`

export const AppraisalSettings: FC = () => {
  const [messageApi, contextHolder] = message.useMessage()
  const [search, setSearch] = useState<string>()

  const { data: users, loading } = useQuery(GetUsers, {
    variables: {
      request: {
        take: 100,
        skip: 0,
        name: search,
        role: {
          in: [UserRole.Admin, UserRole.Appraiser],
        },
      },
    },
  })

  const { data: appraisers } = useQuery(GetUsers, {
    variables: {
      request: {
        take: 100,
        skip: 0,
        role: {
          eq: UserRole.Appraiser,
        },
      },
    },
  })

  const [update] = useMutation(AppraiserUpdate, {
    onCompleted: () => {
      messageApi.success('Appraiser updated successfully')
    },
    onError: (error) => {
      message.error(error.message)
    },
    refetchQueries: [GetUsers],
  })

  
  return (
    <>
      <Space direction='vertical' className='w-100'>
        <label>{translate('appraisers')} : </label>
        <Select
          className='w-100'
          mode='multiple'
          loading={loading}
          value={appraisers?.usersFind.data.map(user => user.id)}
          options={Enumerable.from([
            ...users?.usersFind.data ?? [],
            ...appraisers?.usersFind.data ?? [],
          ])
          .distinct(u => u.id)
          .select(user => ({
            value: user.id,
            label: user.name,
          })).toArray()}
          filterOption={false}
          onSearch={setSearch}
          onChange={(value) => update({ variables: { input: value as number[] } })}
        />
      </Space>
      {contextHolder}
    </>
  )
}
